module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAQJJREFUWEftV8ENwjAQszdhE2AS6CSUSYBJgEnoJodctRWKQhTS0qiQvCqdlPM5Pt+VAGBmBwC1vmc6DYAzySMzJH+tsRaAB4DVTJW7aRoBsEzJ27QFwOIZ2JK8mdkJwD5FS2MZ+A8AZwB3H70kFZOTbgJesgOguPfEPEFLc8r7duCC+ogGYGYS2doBculEGIpNBuDqoTIkwiiBfsJAAaC3dNVcdRrQPuEaUR+bRgM5u6AC4G1Dktps5AOhfcLHzlBPjAhDxUcpPXRBAVAYWDwDGsdqRRnU25H7zS5I9afJfOA3APjG7OjKYi9QF2iKaWLlOO3PqQZJvzgmKTkB+fB7/gSVyRWYymlG/AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn.png
// module id = TQOR
// module chunks = 13